/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="list-ul 1">
      <path
        id="Vector"
        d="M2 2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3C1 3.26522 1.10536 3.51957 1.29289 3.70711C1.48043 3.89464 1.73478 4 2 4C2.26522 4 2.51957 3.89464 2.70711 3.70711C2.89464 3.51957 3 3.26522 3 3C3 2.73478 2.89464 2.48043 2.70711 2.29289C2.51957 2.10536 2.26522 2 2 2ZM5.5 2.5C5.225 2.5 5 2.725 5 3C5 3.275 5.225 3.5 5.5 3.5H15.5C15.775 3.5 16 3.275 16 3C16 2.725 15.775 2.5 15.5 2.5H5.5ZM5.5 7.5C5.225 7.5 5 7.725 5 8C5 8.275 5.225 8.5 5.5 8.5H15.5C15.775 8.5 16 8.275 16 8C16 7.725 15.775 7.5 15.5 7.5H5.5ZM5.5 12.5C5.225 12.5 5 12.725 5 13C5 13.275 5.225 13.5 5.5 13.5H15.5C15.775 13.5 16 13.275 16 13C16 12.725 15.775 12.5 15.5 12.5H5.5ZM3 8C3 7.73478 2.89464 7.48043 2.70711 7.29289C2.51957 7.10536 2.26522 7 2 7C1.73478 7 1.48043 7.10536 1.29289 7.29289C1.10536 7.48043 1 7.73478 1 8C1 8.26522 1.10536 8.51957 1.29289 8.70711C1.48043 8.89464 1.73478 9 2 9C2.26522 9 2.51957 8.89464 2.70711 8.70711C2.89464 8.51957 3 8.26522 3 8ZM2 12C1.73478 12 1.48043 12.1054 1.29289 12.2929C1.10536 12.4804 1 12.7348 1 13C1 13.2652 1.10536 13.5196 1.29289 13.7071C1.48043 13.8946 1.73478 14 2 14C2.26522 14 2.51957 13.8946 2.70711 13.7071C2.89464 13.5196 3 13.2652 3 13C3 12.7348 2.89464 12.4804 2.70711 12.2929C2.51957 12.1054 2.26522 12 2 12Z"
        fill="#262626"
      />
    </g>
  </svg>
);

export default SvgComponent;
